import {ReactElement} from "react";
import * as css from "./styles/SimpleHotWrapperControls.module.scss";

export interface SimpleHoTWrapperControlsProps {
    children: ReactElement | ReactElement[]
}

export function SimpleHoTWrapperControls(props: SimpleHoTWrapperControlsProps): ReactElement {
    return <div className={css.simpleHotWrapperControls}>
        {props.children}
    </div>;
}